export default __webpack_public_path__ + "static/media/table tennis.53e78f81.png";